import React from 'react';
import { Caption } from '~/shared/Typography';
import { VStack, Box, Pressable } from 'native-base';
import { useShopStyles } from '~/shared/styles';

export type VariantCardProps = {
    id: string;
    name: string;
    price: number;
    specialPrice: number | null;
    isSelected: boolean;
    onPress: (id: string) => void;
};

export const VariantCard = ({
    id,
    name,
    price,
    specialPrice,
    isSelected,
    onPress,
}: VariantCardProps) => {

    const { section_background, button_background, button_text } = useShopStyles();

    const percentageCalculator = (): string => {

        return Math.round(((price - specialPrice) / price) * 100) + '% off';
    };

    return (
        <Pressable mr={4} onPress={() => onPress(id)}>
            <VStack
                borderColor={button_background}
                bg={isSelected ? button_background : section_background}
                borderWidth={1}
                rounded={'2xl'}
                px={4} py={2}
                alignItems={'center'}
                justifyContent={'space-evenly'}
                zIndex={1}
                flex={1}
            >
                <Caption color={isSelected ? button_text : button_background}>
                    { name === 'N/A' ? '' : name }
                </Caption>
                <>
                    <Caption
                        color={isSelected ? button_text : button_background}
                        opacity={specialPrice ? .4 : 1}
                        style={specialPrice ? { textDecorationLine: 'line-through' } : {}}
                    >
                        ${ price }
                    </Caption>
                    <Caption color={isSelected ? button_text : button_background}>
                        { specialPrice ? `$${specialPrice}` : '' }
                    </Caption>
                </>
            </VStack>
            { specialPrice &&
                <Box position={'relative'}>
                    <Box
                        position={'absolute'}
                        borderColor={button_background}
                        bg={isSelected ? section_background : button_background}
                        borderWidth={1}
                        borderTopWidth={0}
                        roundedBottom={'lg'}
                        w={'100%'}
                        bottom={0}
                        top={-24}
                        zIndex={-1}
                    ></Box>
                    <Caption
                        textAlign={'center'}
                        p={1}
                        fontSize={12}
                        color={isSelected ? button_background : button_text}
                    >
                        { percentageCalculator() }
                    </Caption>
                </Box>
            }
        </Pressable>
    );
};
